module.exports = __webpack_public_path__ + "static/media/fixo.a7a2935e.png";